module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minimized),
      expression: "minimized"
    }],
    staticClass: "maximize above-map col-sm-12",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        (function () { return _vm.minimized = false; })($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "expand",
      "scale": "2",
      "flip": "horizontal"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.minimized),
      expression: "!minimized"
    }],
    staticClass: "panel above-map",
    class: {
      "has-locations": _vm.campaign.target.locations.length > 0
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaign.target.locations.length),
      expression: "campaign.target.locations.length"
    }],
    staticClass: "location-list"
  }, _vm._l((_vm.campaign.target.locations), function(location, index) {
    var this$1 = this;

    return _c('li', {
      key: JSON.stringify(location)
    }, [_c('b-input-group', {
      staticClass: "location-autocomplete"
    }, [_c('b-button', {
      staticClass: "btn-target",
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_vm._v(_vm._s(_vm.$t('pos.target.location.list-type', {
      type: location.type
    })))]), _c('b-form-input', {
      staticClass: "v-autocomplete-input",
      attrs: {
        "disabled": true,
        "value": ((index+1) + "   " + (location.name)),
        "data-search": index
      }
    }), _c('label', {
      staticClass: "control-label",
      on: {
        "click": function () { return this$1.type = null; }
      }
    }, [_c('icon', {
      attrs: {
        "name": "remove"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onRemoveLocation(index)
        }
      }
    })], 1)], 1)], 1)
  })), _c('locations-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAddLocations),
      expression: "canAddLocations"
    }],
    attrs: {
      "availableCountries": _vm.availableCountries,
      "availableTypes": _vm.availableLocationTypes,
      "selectedLocations": _vm.campaign.target.locations,
      "minLength": 1,
      "disabledButtons": _vm.disabledButtons
    },
    on: {
      "addLocation": _vm.onAddLocation
    }
  }), (_vm.campaign.target.locations.length) ? _c('div', {
    staticClass: "location-settings"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.availableRadiuses.length > 1),
      expression: "availableRadiuses.length > 1"
    }],
    staticClass: "target-box"
  }, [_c('radius-slider', {
    attrs: {
      "radiuses": _vm.availableRadiuses,
      "selected": _vm.campaign.target.radius,
      "unit": _vm.campaign.target.distance_unit
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.target.radius = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "target-box",
    class: {
      "mt-3": _vm.availableRadiuses.length <= 1
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-lg-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pos.target.gender')))])]), _c('div', {
    staticClass: "col-8 col-lg-6 text-right"
  }, [_c('gender-selector', {
    attrs: {
      "selected": _vm.campaign.target.genders
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.target.genders = $event
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "target-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-lg-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pos.target.age')))])]), _c('div', {
    staticClass: "col-8 col-lg-6"
  }, [_c('interval-slider', {
    staticClass: "age-slider",
    attrs: {
      "intervals": _vm.availableAges,
      "selected": _vm.campaign.target.ages
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.target.ages = $event
      }
    }
  })], 1)])]), (_vm.constants.config.interests_enabled) ? _c('div', {
    staticClass: "target-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-lg-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pos.target.interest.caption')))])]), _c('div', {
    staticClass: "col-8 col-lg-6"
  }, [_c('interest-selector', {
    attrs: {
      "interests": _vm.constants.interests,
      "selected": _vm.campaign.target.interests
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.target.interests = $event
      }
    }
  })], 1)])]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.availableLanguages.length > 1),
      expression: "availableLanguages.length > 1"
    }],
    staticClass: "target-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.availableLanguages.length > 3 ? "col-4 col-lg-6" : "col-4 col-lg-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pos.target.language')))])]), _c('div', {
    class: _vm.availableLanguages.length > 3 ? "col-8 col-lg-6" : "col-8 col-lg-9"
  }, [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('language-selector', {
    attrs: {
      "languages": _vm.availableLanguages,
      "selected": _vm.campaign.target.language
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.target.language = $event
      }
    }
  })], 1)])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canPlaceOnInstagram),
      expression: "canPlaceOnInstagram"
    }],
    staticClass: "target-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pos.target.placement')))])]), _c('div', {
    staticClass: "col-9 text-right"
  }, [_c('placement-selector', {
    attrs: {
      "defaultInstagramPlacement": _vm.defaultInstagramPlacement,
      "instagram": _vm.campaign.target.use_instagram
    },
    on: {
      "update:instagram": function($event) {
        _vm.campaign.target.use_instagram = $event
      }
    }
  })], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.constants.locationTypes.length > 1),
      expression: "constants.locationTypes.length > 1"
    }],
    staticClass: "target-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-lg-6"
  }, [_c('location-type-selector', {
    attrs: {
      "options": _vm.constants.locationTypes,
      "selected": _vm.campaign.target.location_types
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.target.location_types = $event
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "bottom-btn-container reach"
  }, [_c('reach-calculator', {
    attrs: {
      "campaign": _vm.campaign,
      "reach": _vm.campaign.potentialReach,
      "cpm": _vm.campaign.cpm,
      "loading": _vm.reachLoading,
      "error": _vm.reachError,
      "target": _vm.campaign.target,
      "unit": _vm.campaign.target.distance_unit
    },
    on: {
      "update:reach": function($event) {
        _vm.campaign.potentialReach = $event
      },
      "update:cpm": function($event) {
        _vm.campaign.cpm = $event
      },
      "update:loading": function($event) {
        _vm.reachLoading = $event
      },
      "update:error": function($event) {
        _vm.reachError = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "reach-warning"
    },
    slot: "reach-warning"
  }, _vm._l((_vm.showReachWarnings), function(mode) {
    return _c('p', {
      staticClass: "subscription-warning"
    }, [_vm._v(_vm._s(_vm.$t('fn.complex.reach-warning', {
      mode: mode
    })))])
  }))]), _c('b-button', {
    staticClass: "btn-confirm btn-block btn-block main-confirm",
    attrs: {
      "variant": _vm.disableNextStep ? "cancel" : "success",
      "disabled": _vm.disableNextStep
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.onSave($event)
      }
    }
  }, [_c('div', {
    staticClass: "larger"
  }, [_vm._v(_vm._s(_vm.$t('pos.target.confirm')))]), (_vm.disableNextStep) ? [_vm._v(_vm._s(_vm.$t('pos.target.not-enough-button')))] : (_vm.canChangeTarget) ? [_vm._v(_vm._s(_vm.$t('pos.target.request-change-of-target')))] : [_vm._v(_vm._s(_vm.$t('pos.target.move-to-offer')))]], 2)], 1), (false) ? _c('div', {
    staticClass: "minimize hidden-md-up",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        (function () { return _vm.minimized = true; })($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "compress",
      "scale": "2",
      "flip": "horizontal"
    }
  })], 1) : _vm._e()]) : _vm._e()], 1), (_vm.showCampaignRecommendationTool) ? _c('campaign-recommendation', {
    attrs: {
      "campaign": _vm.campaign,
      "marketingGoals": _vm.marketingGoals,
      "hideNonMathingGoals": _vm.recommendationToolHideNonMatcingGoals
    },
    on: {
      "startDraftCreation": _vm.addUserCurrentLocation
    }
  }) : _c('campaign-setup', {
    attrs: {
      "campaign": _vm.campaign,
      "showToggleButton": !!_vm.campaign.target.locations.length
    },
    on: {
      "startDraftCreation": _vm.addUserCurrentLocation
    }
  }), (_vm.constants.config.initial_position) ? _c('locations-map', {
    staticClass: "map",
    attrs: {
      "locations": _vm.mapLocations,
      "initial": _vm.constants.config.initial_position,
      "minBounds": _vm.minBounds,
      "panelSelector": "div.panel.above-map",
      "unit": _vm.campaign.target.distance_unit,
      "colors": _vm.colors
    }
  }) : _vm._e()] : _vm._e()], _c('b-modal', {
    ref: "changeTargetModal",
    attrs: {
      "title": _vm.$t("pos.target.target-change-modal-title"),
      "fade": false,
      "hide-footer": true,
      "hide-header-close": true
    }
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('pos.target.target-change-modal-description')))]), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "cancel"
    },
    on: {
      "click": _vm.onHideChangeTargetModal
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))]), _c('b-button', {
    staticClass: "ml-5",
    attrs: {
      "variant": "success",
      "disabled": _vm.changingTarget
    },
    on: {
      "click": _vm.onChangeTarget
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.confirm')))])], 1)]), _c('b-modal', {
    ref: "changeTargetSuccessModal",
    attrs: {
      "hide-footer": true,
      "hide-header": true,
      "hide-header-close": true
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pos.target.target-change-success')))]), _c('b-button', {
    attrs: {
      "variant-success": "variant-success"
    },
    on: {
      "click": _vm.onCloseChangeTargetSuccessModal
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.back-to-campaign')))])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a08ceb20"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-target/CampaignTarget.vue
// module id = 956
// module chunks = 1